module.exports = __webpack_public_path__ + "img/board_title-ar.76caa28c.png";